import { useDatatablesServerSide } from "App/hooks";
import { defaultToastError } from "App/utils/helpers";
import { useContext, useState } from "react";
import { changeLoading, changeRawatJalan } from "../../context/actions";
import { KunjunganRawatJalanCtx } from "../../context/context";
import {
  getByFilterKunjunganRawatJalan,
  RESET_STATE_FORM_FILTER,
} from "../helpers";

function useReloadTable() {
  const { state, dispatch } = useContext(KunjunganRawatJalanCtx);
  const [formFilter, setFormFilter] = useState(RESET_STATE_FORM_FILTER);

  const handleChange = (text) => (e) => {
    setFormFilter((prev) => {
      return {
        ...prev,
        [text]: e.target.value,
        qword:
          text === "type_search" && e.target.value == 0
            ? ""
            : text === "qword"
            ? e.target.value
            : prev.qword,
      };
    });
  };

  const setNewData = async (
    pages = formFilter.pages,
    limit = formFilter.limit,
    formSearch = formFilter
  ) => {
    dispatch(changeLoading(true));
    const response = await getByFilterKunjunganRawatJalan(
      formSearch,
      pages,
      limit
    );
    if (response.state) {
      dispatch(
        changeRawatJalan({
          list: response.data,
          total_data: response.meta.count,
        })
      );
      dispatch(changeLoading(false));
    } else {
      dispatch(
        changeRawatJalan({
          list: [],
          total_data: 0,
        })
      );
      dispatch(changeLoading(true));
      defaultToastError(response.message);
    }
  };

  const {
    pagination,
    onNext,
    onPrevious,
    handleClickPageNumber,
    handleChangeLimit,
    resetPagination,
  } = useDatatablesServerSide({
    setNewData: setNewData,
    additionalProps: formFilter,
  });

  return {
    setNewData,
    loading: state.loading,
    handleChange,
    formFilter,
    setFormFilter,
    pagination,
    onNext,
    onPrevious,
    handleClickPageNumber,
    handleChangeLimit,
    resetPagination,
  };
}

export default useReloadTable;
